import { ref, listAll, deleteObject, StorageReference } from "firebase/storage";
import { storage } from "../firebase";
import { Collection } from "../enums/collections.enum";
import { FirebaseStorageKeys } from "../enums/firebaseStorageKeys.enum";

export const getCompanyImagePath = (companyId: string) => `${Collection.Companies}/${companyId}/${FirebaseStorageKeys.companyImage}-${companyId}`;
export const getBranchImagePath = (companyId: string, branchId: string) => `${Collection.Companies}/${companyId}/${FirebaseStorageKeys.branchImage}-${branchId}`;
export const getUserImagePath = (companyId: string, userId: string) => `${Collection.Companies}/${companyId}/${FirebaseStorageKeys.userImage}-${userId}`;
/**
 * Deletes all files in a storage folder recursively
 * @param folderPath - The path to the folder (e.g., "companies/companyId")
 */
export const deleteStorageFolder = async (folderPath: string): Promise<void> => {
  try {
    const folderRef = ref(storage, folderPath);
    
    // List all items in the folder
    const items = await listAll(folderRef);
    
    // Delete all files in the folder
    const deleteFilePromises = items.items.map((itemRef: StorageReference) => 
      deleteObject(itemRef)
    );
    
    // Delete all subfolders recursively
    const deleteFolderPromises = items.prefixes.map((prefixRef: StorageReference) => 
      deleteStorageFolder(prefixRef.fullPath)
    );
    
    await Promise.all([...deleteFilePromises, ...deleteFolderPromises]);
    
    console.log(`[storageService] Successfully deleted all files in ${folderPath}`);
  } catch (error) {
    // If folder doesn't exist, that's okay - nothing to delete
    if ((error as { code: string }).code === 'storage/object-not-found') {
      console.log(`[storageService] Folder ${folderPath} does not exist, nothing to delete`);
    } else {
      console.error(`[storageService] Error deleting folder ${folderPath}:`, error);
      throw error;
    }
  }
};

/**
 * Deletes a single file from storage
 * @param filePath - The full path to the file
 */
export const deleteStorageFile = async (filePath: string): Promise<void> => {
  try {
    const fileRef = ref(storage, filePath);
    await deleteObject(fileRef);
    console.log(`[storageService] Successfully deleted file ${filePath}`);
  } catch (error) {
    if ((error as { code: string }).code === 'storage/object-not-found') {
      console.log(`[storageService] File ${filePath} does not exist`);
    } else {
      console.error(`[storageService] Error deleting file ${filePath}:`, error);
      throw error;
    }
  }
};

